import type { LucideIcon } from 'lucide-react'
import { UnderlineTabs } from '@/components/common/UnderlineTabs'
import { FileText, Image as ImageIcon, ShieldCheck } from 'lucide-react'
import { useMessages } from '@/i18n'
import { messages } from './messages'

export type EditorTabId = 'content' | 'cover' | 'access'

interface TabDef {
  id: EditorTabId
  icon: LucideIcon
  label: string
}

interface Props {
  active: EditorTabId
  onChange: (id: EditorTabId) => void
}

/** Разделы редактора инструкции — верхним меню, как в настройках курса. */
export const EditorRail = ({ active, onChange }: Props) => {
  const m = useMessages(messages)
  const tabs: TabDef[] = [
    { id: 'content', icon: FileText, label: m.tabContent },
    { id: 'cover', icon: ImageIcon, label: m.tabCover },
    { id: 'access', icon: ShieldCheck, label: m.tabAccess },
  ]
  return <UnderlineTabs tabs={tabs} value={active} onChange={onChange} />
}
